import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import placeholderImage from '../../assets/placeholder.jpg';
import DiscountBadge from './DiscountBadge';
import ColorSwatch from './ColorSwatch';
import ProductListPrice from './ProductListPrice';
import ProductItem from "../ProductItem";

export default function Loopingproduct(props) {
    const ServicesRef = useRef(null);
    const wishlistItems = useSelector(state => state?.cart?.wishlistItems);
    const filterData = props.products;



    return (
        <>

            {Array.isArray(filterData) &&
                <>
                    {filterData?.map((dt) => {
                        const localId = localStorage.getItem("mylocalid");
                        const itemProps = dt?._id === localId ? { ref: ServicesRef } : {};
                        const isInWishlist = wishlistItems?.some((item) => item?._id === dt?._id);

                        return (
                            <ProductItem
                                item={dt}
                                key={dt?._id}
                                addItemToWishlist={props.addItemToWishlist}
                            />
                        );
                    }
                    )}
                </>
            }



        </>
    )
}
